import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { connect } from 'react-redux';
import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import { ruleRunner, run } from 'validations/ruleRunner';
import { isEmail, required } from 'validations/rules';

import type { DispatchProp } from 'react-redux';

const fieldValidations = {
  newEmail: ruleRunner('newEmail', 'e-mail', required, isEmail),
};

interface IProps extends DispatchProp<any> {
  classes: any;
  invoice: any;
  email: string;
}

interface IStates {
  openModal: boolean;
  validationErrors: any;
  newEmail: string;
  emailChanged: string;
}

class Client extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      openModal: false,
      newEmail: '',
      emailChanged: '',

      validationErrors: {},
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleClickEdit = () => {
    this.toggleModal();
  };

  toggleModal = () => {
    this.setState({
      openModal: !this.state.openModal,
    });
  };

  handleCloseModal = () => {
    this.setState({
      newEmail: '',
      validationErrors: {},
    });
    this.toggleModal();
  };

  onValidation = (field: string) => {
    let validationErrors = this.state.validationErrors;
    let obj = run(this.state, [fieldValidations[field]]);

    validationErrors[field] = obj[field];

    for (let prop in validationErrors) {
      if (!validationErrors[prop]) {
        delete validationErrors[prop];
      }
    }

    this.setState({
      validationErrors,
    });
  };

  handleChangeField = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.value;

    this.setState(newState, () => this.onValidation(name));
  };

  render() {
    const canChargeAnotherUser = Boolean(localStorage.getItem('eadCharging'));
    const shouldShowPayerAndStudent = canChargeAnotherUser && this.props.invoice.student_customer && this.props.invoice.student_customer.id;

    const actionsToShowClientData = ['myeduzz:minhas-vendas:ver-dados-clientes', 'myeduzz:meus-contratos:ver-dados-clientes'];

    return (
      <React.Fragment>
        <div className={this.props.classes.rowValues}>
          {shouldShowPayerAndStudent ? <h4>Responsável financeiro</h4> : <h4>Detalhes do cliente</h4>}

          <div className='content__client'>
            {this.props.invoice.customer && this.props.invoice.customer.name && (
              <div className='row__client'>
                <div className='client__title'>Nome</div>
                <PermissionHide action={actionsToShowClientData}>{this.props.invoice.customer.name}</PermissionHide>
                <PermissionHide inverse action={actionsToShowClientData}>
                  oculto
                </PermissionHide>
              </div>
            )}

            {this.props.invoice.customer && this.props.invoice.customer.document_number && (
              <div className='row__client'>
                <div className='client__title'>CPF</div>
                <PermissionHide action={actionsToShowClientData}>{this.props.invoice.customer.document_number} </PermissionHide>
                <PermissionHide inverse action={actionsToShowClientData}>
                  oculto
                </PermissionHide>
              </div>
            )}

            {this.props.invoice.customer && this.props.invoice.customer.email && (
              <div className='row__client'>
                <div className='client__title'>E-mail</div>

                <PermissionHide action={actionsToShowClientData}>
                  {this.state.emailChanged ? this.state.emailChanged : this.props.email ? this.props.email : 'Carregando...'}
                </PermissionHide>
                <PermissionHide inverse action={actionsToShowClientData}>
                  oculto
                </PermissionHide>
              </div>
            )}

            {this.props.invoice.customer && this.props.invoice.customer.celphone && (
              <div className='row__client'>
                <div className='client__title'>Fone</div>
                <PermissionHide action={actionsToShowClientData}>
                  <WhatsAppLink phone={this.props.invoice.customer.celphone} />
                </PermissionHide>
                <PermissionHide inverse action={actionsToShowClientData}>
                  oculto
                </PermissionHide>
              </div>
            )}

            {this.props.invoice.customer && this.props.invoice.customer.address && (
              <React.Fragment>
                <div className='row__client'>
                  <div className='client__title'>Endereço</div>
                  <PermissionHide action={actionsToShowClientData}>
                    {this.props.invoice.customer.address.street && `${this.props.invoice.customer.address.street}, `}
                    {this.props.invoice.customer.address.number && `${this.props.invoice.customer.address.number} - `}
                    {this.props.invoice.customer.address.complement && `${this.props.invoice.customer.address.complement} - `}
                    {this.props.invoice.customer.address.neighborhood && `${this.props.invoice.customer.address.neighborhood} - `}
                    {this.props.invoice.customer.address.city && `${this.props.invoice.customer.address.city}`}
                    {this.props.invoice.customer.address.state && ` - ${this.props.invoice.customer.address.state}`}
                    {this.props.invoice.customer.address.country && ` - ${this.props.invoice.customer.address.country}`}
                    {this.props.invoice.customer.address.zip_code && ` CEP: ${this.props.invoice.customer.address.zip_code}`}
                  </PermissionHide>
                  <PermissionHide inverse action={actionsToShowClientData}>
                    oculto
                  </PermissionHide>
                </div>
              </React.Fragment>
            )}

            {this.props.invoice.customer &&
              !this.props.invoice.customer.address &&
              !this.props.invoice.customer.address.city &&
              !this.props.invoice.customer.address.country &&
              !this.props.invoice.customer.address.neighborhood &&
              !this.props.invoice.customer.address.state &&
              !this.props.invoice.customer.address.street &&
              !this.props.invoice.customer.address.zip_code &&
              !this.props.invoice.customer.address.number && (
                <div className='row__client'>
                  <div className='client__title'>Endereço</div>
                  <PermissionHide action={actionsToShowClientData}>-</PermissionHide>
                  <PermissionHide inverse action={actionsToShowClientData}>
                    oculto
                  </PermissionHide>
                </div>
              )}
          </div>

          {shouldShowPayerAndStudent && (
            <React.Fragment>
              <div className='m24' />

              <h4>Aluno</h4>

              <div className='content__client'>
                {this.props.invoice.student_customer && this.props.invoice.student_customer.name && (
                  <div className='row__client'>
                    <div className='client__title'>Nome</div>
                    <PermissionHide action={actionsToShowClientData}>{this.props.invoice.student_customer.name}</PermissionHide>
                    <PermissionHide inverse action={actionsToShowClientData}>
                      oculto
                    </PermissionHide>
                  </div>
                )}

                {this.props.invoice.student_customer && this.props.invoice.student_customer.email && (
                  <div className='row__client'>
                    <div className='client__title'>E-mail</div>

                    <PermissionHide action={actionsToShowClientData}>{this.props.invoice.student_customer.email}</PermissionHide>
                    <PermissionHide inverse action={actionsToShowClientData}>
                      oculto
                    </PermissionHide>
                  </div>
                )}

                {this.props.invoice.student_customer && this.props.invoice.student_customer.celphone && (
                  <div className='row__client'>
                    <div className='client__title'>Fone</div>
                    <PermissionHide action={actionsToShowClientData}>
                      <WhatsAppLink phone={this.props.invoice.student_customer.celphone} />
                    </PermissionHide>
                    <PermissionHide inverse action={actionsToShowClientData}>
                      oculto
                    </PermissionHide>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default connect()(Client);
